export default theme => {
  return {
    container: {
      height: '100%',
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
      overflow: 'hidden'
    },
    headerGrid: {
      height: 20
    },
    brandImage: {
      height: 20,
    },
    brandLogo: {
      height: 15,
      marginBottom: 5
    },
    icon: {
      fontSize: 14,
      marginRight: 4,
      marginBottom: -3,
      color: theme.palette.grey[600]
    },
    center: {
      display: 'block',
      margin: 'auto',
      width: 'max-content'
    },
    headerMetric: {
      fontWeight: 'bold'
    },
    stat: {
      marginRight: 5,
      marginLeft: 5,
      borderRadius: 8
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Demo/InvestorServices/theme/components/scorecard/ScorecardView/ScorecardScroller/ScorecardScrollableColumn/ScorecardAdHeader.js